import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Logo from "../../../assets/notifylog.png";
import { login } from "../../../services/auth";

import { Form, Container } from "./styles";
import useAuth from "../../../components/hooks/useAuth";
import Loader from "../../../components/Loader";
import { Typography } from "@mui/material";

const ComponentSignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!email || !password) {
      setError("Preencha e-mail e senha para continuar!");
    } else {
      try {
        const response = await signIn(email, password);
        console.log(response);
        if (response.success == false) {
          setError(response.message.toString());
        } else {
          window.location.href = "/app";
        }
      } catch (err) {
        setError(
          "Houve um problema com o login, verifique suas credenciais. T.T"
        );
      }

      setLoading(false);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSignIn}>
        <img src={Logo} alt="Notify" />
        <h4>Seja bem vindo(a)!</h4>
        {error && <p>{error}</p>}

        <div className="mb-1">
          <input
            type="email"
            className="form-control w-100"
            id="exampleFormControlInput1"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="mb-1">
          <input
            type="password"
            className="form-control w-100"
            id="inputPassword"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button type="submit" className="w-100" disabled={loading}>
          Entrar
        </button>
        {loading && <Loader></Loader>}
        <hr />
        <Link to="/forgot-password">Esqueceu a sua senha?</Link>

        <Link to="/sign-up/">Crie sua conta</Link>
      </Form>
    </Container>
  );
};

export default ComponentSignIn;
